import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/code1.png'
import _imports_1 from '@/assets/images/code2.png'
import _imports_2 from '@/assets/images/beian-icon.png'


const _hoisted_1 = { class: "bottom-box" }
const _hoisted_2 = { class: "bottom-content" }
const _hoisted_3 = { class: "bottom-wrap" }
const _hoisted_4 = { class: "bottom-right" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "filings" }

import { useRouter } from 'vue-router';
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const store = useStore()
const router = useRouter()
const linkList: any = [
  {
    title: '产品服务',
    value: [
      {
        name: '混空 Studio',
        path: '/studio'
      },
      {
        name: '混空 VPS',
        path: '/vps'
      }
    ]
  },
  {
    title: '通用解决方案',
    value: [
      // {
      //   name: '空间视觉技术',
      //   path: '/solution',
      //   index: 3,
      // },
      {
        name: 'VR虚拟仿真',
        path: '/solution',
        index: 5,
      },
      {
        name: 'AR导航导览',
        path: '/solution',
        index: 7,
      },
      {
        name: 'AR小程序',
        path: '/solution',
        index: 4,
      },
      {
        name: '虚拟博物馆',
        path: '/solution',
        index: 6,
      },
      {
        name: '元宇宙展厅',
        path: '/solution',
        index: 8,
      }
    ]
  },
  {
    title: '行业解决方案',
    value: [
      {
        name: '文娱解决方案',
        path: '/solution',
        index: 0,
      },
      {
        name: '工业解决方案',
        path: '/solution',
        index: 1,
      },
      {
        name: '教育解决方案',
        path: '/solution',
        index: 2,
      },
    ]
  },
  {
    title: '关于我们',
    value: [
      {
        name: '公司介绍',
        path: '/about-us',
      },
      {
        name: '加入我们',
        path: '/about-us',
        index: 8,
      },
      {
        name: '公司新闻',
        path: '/company-news',
        index: 5,
      },
      {
        name: '行业新闻',
        path: '/company-news',
        index: 6,
      },
      {
        name: '隐私政策',
        path: '/about-us-privacy_policy',
      }
    ]
  },
  {
    title: '合作咨询',
    value: [
      {
        name: '座机',
        path: '',
        type: 'phone-title'
      },
      {
        name: '400-900-6269',
        path: '',
        type: 'phone'
      }
    ]
  },
]

const to1 = (url: string) => {
  window.scrollTo(0, 0)
  window.location.href = url
}

const changeRouter = (e: any, titleIndex: number) => {
  if (!e.path) return
  window.scrollTo(0, 0);
  if (e.path == '/solution' || e.path == '/company-news' || e.path == '/about-us') {
    router.push(`${e.path}?type=${e.index}`)
    store.state.programmeIndex = e.index
  } else {
    router.push(`${e.path}`);
  }
  window.localStorage.setItem('activePath', e.path)
  store.state.activePath = e.path;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("div", { class: "bottom-logo" }, [
            _createElementVNode("span", null, "混空"),
            _createElementVNode("span", null, "Mixed Space")
          ]),
          _createElementVNode("div", { class: "bottom-codes" }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", { src: _imports_0 }),
              _createElementVNode("div", null, "公众号")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("img", { src: _imports_1 }),
              _createElementVNode("div", null, "视频号")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(linkList, (item, index) => {
            return _createElementVNode("div", { key: index }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (e, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["url-list", e.type || '']),
                  key: i,
                  onClick: ($event: any) => (changeRouter(e, e.titleIndex))
                }, _toDisplayString(e.name), 11, _hoisted_6))
              }), 128))
            ])
          }), 64))
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "line" }, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "company-address" }, "上海市徐汇区钦州北路1001号光启园7号楼6层", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            style: {"color":"#929292"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (to1('https://beian.miit.gov.cn/#/Integrated/index')))
          }, "沪ICP备2023012463号—1"),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "版权所有 ©️ 2023上海凝聚元界信息科技有限公司", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
          _createElementVNode("span", {
            style: {"color":"#929292"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (to1('https://beian.mps.gov.cn/#/query/webSearch')))
          }, "沪公网安备 31010402010108号")
        ])
      ])
    ])
  ]))
}
}

})